import {  ExternalLink } from 'lucide-react';
import { Card, CardContent, CardTitle, CardHeader, CardDescription } from '@/components/ui/card';
import { NavLink } from 'react-router-dom' ;
import { Video } from '@/types/videos';

export default function VideoCard({ item }: { item: Video }) {
  return (
    <Card key={item.title} className="flex flex-col justify-between h-full">
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span className="flex items-center gap-2">
            {item.title} 
            {item.link && <NavLink to={item.link} className="text-sm text-muted-foreground"><ExternalLink className="size-4" /></NavLink>} 
          </span>
        </CardTitle> 
        <CardDescription>{item.description}</CardDescription>
      </CardHeader>
      <CardContent className="flex items-end">
        <div className="relative w-full h-[300px]" style={{ paddingBottom: 0 }}>
          <iframe src={item.video_url} frameBorder="0" allowFullScreen className="absolute top-0 left-0 bottom-0 right-0 w-full h-full rounded-lg" />
        </div>
      </CardContent>
    </Card>
  );
}   
